import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@repo/ui/components/breadcrumb"
import { Separator } from "@repo/ui/components/separator"
import { SidebarTrigger } from "@repo/ui/components/sidebar"
import { useContext } from "react"
import { Link, useLocation } from "react-router"

import { CommandPalette } from "@/components/command-palette"
import { ThemeToggle } from "@/components/theme-toggle"
import { BreadcrumbContext } from "@/lib/breadcrumb-context"
import { findNavItem, findNavTitle } from "@/lib/nav"

export function Topbar() {
  const { pathname } = useLocation()
  const item = findNavItem(pathname)
  const title = findNavTitle(pathname)
  const { label } = useContext(BreadcrumbContext)
  // A detail page names itself, and the section it belongs to becomes a link back.
  const detail = label !== null && item !== undefined && pathname !== item.to

  return (
    <header className="sticky top-0 z-50 flex h-(--header-height) shrink-0 items-center gap-2 border-b bg-background/80 px-4 backdrop-blur-md sm:px-6 md:rounded-t-xl">
      <SidebarTrigger className="-ml-1" />
      <Separator
        orientation="vertical"
        className="mx-1 self-center data-[orientation=vertical]:h-4"
      />
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem className="hidden md:block">
            <BreadcrumbLink render={<Link to="/" />}>Dashboard</BreadcrumbLink>
          </BreadcrumbItem>
          {pathname !== "/" && (
            <>
              <BreadcrumbSeparator className="hidden md:block" />
              <BreadcrumbItem>
                {detail ? (
                  <BreadcrumbLink render={<Link to={item.to} />}>
                    {title}
                  </BreadcrumbLink>
                ) : (
                  <BreadcrumbPage>{title}</BreadcrumbPage>
                )}
              </BreadcrumbItem>
              {detail && (
                <>
                  <BreadcrumbSeparator />
                  <BreadcrumbItem>
                    <BreadcrumbPage>{label}</BreadcrumbPage>
                  </BreadcrumbItem>
                </>
              )}
            </>
          )}
        </BreadcrumbList>
      </Breadcrumb>

      <div className="ml-auto flex items-center gap-1">
        <CommandPalette />
        <ThemeToggle />
      </div>
    </header>
  )
}
